import { AuthSdk } from "./auth-sdk";
var instance = null;
var getAuthSdk = function (_a) {
    var oktaConfig = _a.oktaConfig, env = _a.env;
    if (!instance) {
        instance = new AuthSdk({ app: "login-app", oktaConfig: oktaConfig, env: env });
    }
    return instance;
};
export { getAuthSdk };
